import { useEffect } from "react";

const ORG = {
  "@type": "Organization",
  name: "The Fin Desk",
  url: "https://thefindesk.com",
  description: "Independent reporting on fintech, payments, banking and financial infrastructure.",
  slogan: "Finance. Fintech. Payments. Intelligence.",
};

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) { el = document.createElement("link"); el.setAttribute("rel", "canonical"); document.head.appendChild(el); }
  el.setAttribute("href", href);
}

function setJsonLd(blocks) {
  document.querySelectorAll('script[data-seo-jsonld="1"]').forEach((n) => n.remove());
  (blocks || []).filter(Boolean).forEach((obj) => {
    const s = document.createElement("script");
    s.type = "application/ld+json";
    s.setAttribute("data-seo-jsonld", "1");
    s.text = JSON.stringify({ "@context": "https://schema.org", ...obj });
    document.head.appendChild(s);
  });
}

export function applySeo({ title, description, image, url, type = "website", jsonLd } = {}) {
  const fullTitle = title ? `${title} — The Fin Desk` : "The Fin Desk — Finance. Fintech. Payments. Intelligence.";
  document.title = fullTitle;
  const canonical = url || window.location.href;
  upsertMeta("name", "description", description);
  upsertMeta("property", "og:title", title || "The Fin Desk");
  upsertMeta("property", "og:description", description);
  upsertMeta("property", "og:type", type === "article" ? "article" : "website");
  upsertMeta("property", "og:url", canonical);
  upsertMeta("property", "og:site_name", "The Fin Desk");
  if (image) upsertMeta("property", "og:image", image);
  upsertMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
  upsertMeta("name", "twitter:title", title || "The Fin Desk");
  upsertMeta("name", "twitter:description", description);
  if (image) upsertMeta("name", "twitter:image", image);
  setCanonical(canonical);
  setJsonLd(jsonLd);
}

export function useSeo(config) {
  const key = JSON.stringify(config || {});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { if (config) applySeo(config); }, [key]);
}

export function organizationJsonLd() { return ORG; }
